const KeyboardKey = ({letter, keyPressCallback, highlight}) => {
    return (
        <div className='keyboardKeyLetter' highlight={highlight}onClick={() => {
            keyPressCallback(letter);
        }}>
            {letter}
        </div>
    )
}

export default KeyboardKey;